<template>
  <VariationAlert
    v-for="variation in variations"
    :key="variation.applicantId"
    :variation="variation"
    :applicant="getApplicant(form, variation.applicantId)"
    @basketClick="basketVisible = true"
  />

  <AppDialog v-model="basketVisible">
    <BasketSummary :form />
  </AppDialog>
</template>

<script setup lang="ts">
import { getApplicant } from '~/helpers/visa-form';
import type { ApplicableVariation, VisaForm } from '~/types';

defineProps<{
  variations: ApplicableVariation[];
  form: VisaForm;
}>();

const basketVisible = ref(false);
</script>